export default class Month {
    constructor(year, month, locale = "fr", startDay = 1) {
        this._year = year;
        this._month = month;
        this._start = startDay;
        this._end = startDay + 6 == 7 ? 0 : startDay + 6;
        this._lstDays = this._genList();
        this._locale = locale;
        this.monthName = this._getMonthName()
        this.listDaysNames = this._getListDaysNames()
        this.days = this._lstDays
    }

    _genList() {
        let fday = 1;
        let first = new Date(Date.UTC(this._year, this._month, fday));

        while (first.getDay() != this._start && fday > -7) {
            first = new Date(Date.UTC(this._year, this._month, --fday));
        }

        let day = new Date(first);
        let nextMonth = this._month != 11 ? this._month + 1 : 0;
        let listDays = [];
        while (day.getMonth() != nextMonth) {
            listDays.push(new Date(day));
            day = new Date(Date.UTC(this._year, this._month, ++fday));
        }

        while (day.getDay() != this._start) {
            listDays.push(new Date(day));
            day = new Date(Date.UTC(this._year, this._month, ++fday));
        }

        return listDays;
    }

    getYear() {
        return this._year;
    }

    getMonth() {
        return this._month;
    }

    _getMonthName() {
        let option = {
            month: 'long'
        };
        let format = new Intl.DateTimeFormat(this._locale, option);
        return format.format(new Date(Date.UTC(this._year, this._month)));
    }

    _getListDaysNames() {
        let fday = 1;
        let day = new Date(Date.UTC(this._year, this._month, fday));

        let option = {
            weekday: 'short'
        };
        let format = new Intl.DateTimeFormat(this._locale, option);

        while (day.getDay() != this._start) {
            fday++;
            day = new Date(Date.UTC(this._year, this._month, fday));
        }

        let lstDaysNames = []
        for (let i = 0; i < 7; i++) {
            lstDaysNames.push(format.format(new Date(Date.UTC(this._year, this._month, fday + i))))
        }
        return lstDaysNames
    }

    getStartDay() {
        return this._start;
    }

    log() {
        this._lstDays.forEach(d => {
            // eslint-disable-next-line no-console
            console.log(d, d.getDay());
        });
    }
}